import { Checkbox, makeStyles } from '@material-ui/core';

export default function MultiSelectOption({ selected, children }) {

    const classes = useStyles();

    return (
        <>
            {
                <Checkbox
                    size='small'
                    color='primary'
                    checked={selected}
                    tabIndex={-1}
                    disableRipple
                    classes={{ root: classes.checkboxRoot }}
                />
            }
            {children}
        </>
    )
}

const useStyles = makeStyles(theme => ({
    checkboxRoot: {
        padding: theme.spacing(0),
        marginRight: theme.spacing(1)
    }
}));